<template>
    <div class="form-group row">
        <div class="col-md-4">
            <label class="select-label" for="usertype">Access Level</label>

            <select class="form-control" id="usertype" v-model="user.userType" :disabled="((!adding && !editing) || editing)" required>
                <option v-for="userType in userTypes" :value="userType.value">{{userType.text}}</option>
            </select>
        </div>
    </div>

    <div v-if="user.userType === regTypes.AGENCY" class="form-group row">
        <div class="col-md-4">
            <label class="select-label" for="agencytype">Agency Type</label>

            <select class="form-control" id="agencytype" v-model="user.agencyFields.agencyType" :disabled="!adding && !editing" required>
                <option v-for="agencyType in agencyTypes" :value="agencyType">{{agencyType}}</option>
            </select>
        </div>
    </div>

    <p v-html="userTypeText" class="text-muted"></p>

    <div v-if="user.userType === regTypes.ATTORNEY" class="form-group row">
        <div class="col-md-4">
            <label for="inputBarNumber">Bar Number</label>
            <input type="text" v-maska data-maska="#########" class="form-control" id="inputBarNumber" placeholder="Bar Number" v-model="user.attorneyFields.barNumber" :disabled="!adding && !editing" required>
        </div>
    </div>

    <div v-if="user.userType === regTypes.PARTYONCASE" class="form-group row">
        <div class="col-md-4">
            <label for="inputDLNumber">DL Number</label>
            <input type="text" class="form-control" id="inputDLNumber" placeholder="DL Number" v-model="user.partyToCaseFields.dlNumber" :disabled="!adding && !editing" required>
        </div>
    </div>

    <div v-if="user.userType === regTypes.PARTYONCASE" class="form-group row">
        <div class="col-md-4">
            <label for="txtPicklistItem">Cases for Party Viewing</label>

            <div class="input-group">
                <input type="text" v-maska data-maska="##-####-@@-######-@@@@-@@" data-toggle="tooltip" data-placement="right" title="Example: 50-2013-CF-123456-AXXX-MB"
                       id="txtPicklistItem" class="form-control" v-model="newCasePicklistItem" :disabled="!adding && !editing" />
                <span class="input-group-btn">
                    <button type="button" title="Add Item" class="btn pull-right" style="margin-left: 0.5em;" @click="addCasePicklistItem" :disabled="!adding && !editing">
                        <span class="glyphicon glyphicon-plus"></span> Add
                    </button>
                </span>
            </div>

            <ul class="list-group picklist-item-container">
                <li v-for="e in casesPicklistArray"
                    class="list-group-item list-group-item-secondary" style="font-size:medium;">
                    <div class="row">
                        <div class="col-md-10">{{e}}</div>
                        <div class="col-md-2">
                            <button type="button" title="Delete Item" class="btn" style="padding:0" @click="deleteCasePicklistItem(e)" :disabled="!adding && !editing">
                                <span class="glyphicon glyphicon-remove"></span>
                            </button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <div class="form-group row">
        <div class="col-md-4">
            <label for="inputFirstName">First Name</label>
            <input type="text" class="form-control" id="inputFirstName" placeholder="First Name" v-model="user.firstName" :disabled="!adding && !editing" autocomplete="given-name" required>
        </div>
        <div class="col-md-4">
            <label for="inputMiddleName">Middle Name</label>
            <input type="text" class="form-control" id="inputMiddleName" placeholder="Middle Name" v-model="user.middleName" :disabled="!adding && !editing" autocomplete="additional-name">
        </div>
        <div class="col-md-4">
            <label for="inputLastName">Last Name</label>
            <input type="text" class="form-control" id="inputLastName" placeholder="Last Name" v-model="user.lastName" :disabled="!adding && !editing" autocomplete="family-name" required>
        </div>
    </div>

    <div class="form-group row">
        <div class="col-md-4">
            <label for="inputAddress">Address</label>
            <input type="text" class="form-control" id="inputAddress" placeholder="Address" v-model="user.address" :disabled="!adding && !editing" autocomplete="street-address">
        </div>
        <div class="col-md-4">
            <label for="inputCity">City</label>
            <input type="text" class="form-control" id="inputCity" placeholder="City" v-model="user.city" :disabled="!adding && !editing" autocomplete="address-level2">
        </div>
        <div class="col-md-2">
            <label for="inputState">State</label>
            <input type="text" class="form-control" id="inputState" placeholder="State" v-model="user.state" :disabled="!adding && !editing" autocomplete="address-level1">
        </div>
        <div class="col-md-2">
            <label for="inputZip">Zip</label>
            <input type="text" class="form-control" id="inputZip" placeholder="Zip" v-model="user.zip" :disabled="!adding && !editing" autocomplete="postal-code">
        </div>
    </div>

    <div class="form-group row">
        <div class="col-md-4">
            <label for="inputEmail">Email</label>
            <input type="email" class="form-control" id="inputEmail" placeholder="Email" v-model="user.email" :disabled="!adding" autocomplete="email" required>
        </div>
    </div>

    <div class="form-group row">
        <div class="col-md-4">
            <label for="inputPhone">Phone</label>
            <input type="text" v-maska data-maska="###-###-####" class="form-control" id="inputPhone" placeholder="Phone" v-model="user.phone" :disabled="!adding && !editing" autocomplete="tel">
        </div>
        <div class="col-md-4">
            <label for="inputAltPhone">Alternate Phone</label>
            <input type="text" v-maska data-maska="###-###-####" class="form-control" id="inputAltPhone" placeholder="Alternate Phone" v-model="user.altPhone" :disabled="!adding && !editing" autocomplete="tel">
        </div>
    </div>

</template>

<style scoped>
    .select-label {
        display: inline;
    }

    .custom-button {
        width: 48%;
    }

    .picklist-item-container {
        max-height: 200px;
        /* max-width: 300px;*/
        /*overflow-y: auto;*/
        /*padding: 0.25rem 1rem 0.25rem;*/
        /*margin-left: 0.5rem;*/
        font-size: 0.9rem;
        margin-top: 1rem;
    }
</style>

<script setup>

    import { storeToRefs } from 'pinia';
    import { useUserStore, userRegTypes } from '@/stores/user.store';
    import { defineProps, reactive, ref, computed } from "vue";
    import { vMaska } from 'maska';

    const userStore = useUserStore();
    const regTypes = userRegTypes;

    const { userTypes, user, adding, editing, agencyTypes } = storeToRefs(userStore);

    const props = defineProps({
        confid: {
            type: String,
            required: false,
        }
    });

    let confID = ref();

    let newCasePicklistItem = ref();

    const userTypeText = computed({

        get() {

            let config = userStore.userConfig;

            if (config) {

                switch (userStore.user.userType) {
                    case regTypes.REGUSER:
                        return config.registereduser.info;
                    case regTypes.ATTORNEY:
                        return config.attorney.info;
                    case regTypes.AGENCY:
                        return config.agency.info;
                    case regTypes.PARTYONCASE:
                        return config.partytoacase.info;
                }
            }
        }
    })

    const casesPicklistArray = computed({

        get() {

            if (userStore.user.partyToCaseFields.cases == null) userStore.user.partyToCaseFields.cases = '';

            if (userStore.user.partyToCaseFields.cases != '') {
                var arr = userStore.user.partyToCaseFields.cases.split("|");

                var trimmed_arr = arr.filter(element => {
                    element = element.trim();
                    if (element && element != '') return element;
                });

                return trimmed_arr.sort();
            }
            else
                return [];
        }
    })

    function addCasePicklistItem() {

        if (newCasePicklistItem.value.trim() == '') return;
        if (userStore.user.partyToCaseFields.cases == null) {
            userStore.user.partyToCaseFields.cases = newCasePicklistItem.value.trim() + "|";
        }
        else {
            let found = false;

            if (userStore.user.partyToCaseFields.cases != '') {
                var arr = userStore.user.partyToCaseFields.cases.split("|");

                if (arr.includes(newCasePicklistItem.value.trim())) {
                    found = true;
                }
            }

            if (!found) {
                userStore.user.partyToCaseFields.cases += newCasePicklistItem.value.trim() + "|";
            }
        }

        newCasePicklistItem.value = '';
    }

    function deleteCasePicklistItem(item) {
        userStore.user.partyToCaseFields.cases = userStore.user.partyToCaseFields.cases.replace(item + "|", '');
    }

    async function load() {
        confID = props.confid;
    };

    (async () => {
        await load();
    })();

</script>
